import React, { useState, useEffect } from 'react'

import CreatableSelect from 'react-select/creatable'

const normalizeOptions = options => {
  return options.map(value => {
    if (typeof value === 'string') {
      return {
        label: value,
        value
      }
    }

    return {
      label: value.text,
      value: value.value
    }
  })
}

const transformValues = (values, options, isMulti) => {
  if (isMulti) {
    return values.map(value => {
      // in case we have the option we display it, to have nice labels!
      const option = options.find(option => option.value === value)
      return option ? option : { value: value, label: value }
    })
  }

  const option = options.find(option => option.value === values)
  return option ? option : { value: values, label: values }
}

const getSelectedValues = (question, isMulti) => {
  if (isMulti) {
    return question && question.value ? question.value : []
  }

  return question && question.value ? question.value : null
}

const MultiSelectWrapper = ({ question, isMulti = true }) => {
  const [options, setOptions] = useState([])
  const [values, setValues] = useState([])

  useEffect(() => {
    const choices = question && question.getPropertyValue('choices')
    const selectedValue = getSelectedValues(question)
    let newChoices = []
    if (choices) {
      newChoices = normalizeOptions(choices)
      setOptions(newChoices)
    }

    if ((isMulti && selectedValue.length > 0) || (!isMulti && selectedValue)) {
      setValues(transformValues(selectedValue, newChoices, isMulti))
    }
  }, [question])

  const onChange = (newValue, _actionMeta) => {
    setValues(newValue)
    question.value = isMulti ? newValue.map(value => value.value) : newValue.value
  }

  return (
    <CreatableSelect
      options={options}
      value={values}
      isDisabled={question.isReadOnly}
      onChange={onChange}
      isMulti={isMulti}
      menuPortalTarget={document.body}
    />
  )
}

export default MultiSelectWrapper
